// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"215":"724cdc47","413":"332d5a7e","522":"145f112b","576":"cc209214","638":"145f112b","692":"145f112b"}[chunkId] + ".chunk.css";
};